


import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { withRouter } from 'react-router-dom';
import LoadingSpinner from "src/components/LoadingSpinner";
import Footerpage from "src/components/footer";
// import AgreementComponent from "src/components/agreementModal";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
import Headerpage from "src/components/header";
const styles = () => ({
    childTemplate: {
        paddingLeft: 80,
    },
    listItem: {
        "&:hover": {
            backgroundColor: "#e6e6e6",
        },
        backgroundColor: "white",
    },
});

type IProps = IAxiosProps & IAppContext &
    WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
    paymentDetails: any
    loader: boolean;
    openAgreement: boolean;
    paymentMethodType: number;
    isAgree: boolean;
    selectedFile: any;

}

const Home = withStyles(styles)(
    withAxios(
        class LeadPage extends Component<IProps, ITemplatesPageState> {
            public state = this.buildState({
                paymentDetails: {},
                loader: false,
                openAgreement: false,
                paymentMethodType: 0,
                isAgree: false,
                selectedFile: null
            });
            public componentWillMount(): void {
                // this.props.getNewLoginUserDetails()
            }
            public componentDidMount() {
                this.getAllPlanHandler()
            }
            public componentWillUnmount() {
                // Cleanup if needed
            }

            public openAgreementModal() {
                this.setState({ openAgreement: true })
            }
            public closeAgreementModal() {
                this.setState({ openAgreement: false })
            }

            public paymentMethodsType(id: any) {
                this.setState({ paymentMethodType: id })

            }

            public async getAllPlanHandler() {
                this.setState({ loader: true })
                const planId: any = this.props.newUserDetails?.subscriptionPlan?.id
                const addonId: any = this.props.newUserDetails?.addonPlan || []
                const paymentData = {
                    // "payment_method":"cheque",
                    "plan_id": planId,
                    "addon_id": addonId
                }
                const res: any = await this.buildPost(this, "payment/planPayNow")(paymentData)
                if (res.status && Object.keys(res?.data)?.length > 0) {
                    this.setState({ paymentDetails: { ...res?.data, addon: res?.data?.addon == null ? [] : res?.data?.addon, plan: res?.data?.plan != null ? res?.data?.plan : {} } }, () => {
                        console.log("paymentDetails======>", this.state.paymentDetails)
                    })
                    this.setState({ loader: false })
                } else {
                    this.setState({ loader: false })
                }
                // this.setState({ user: res })
            }
            public TwoDecimalFloat(amount: any) {
                const valueAnount = amount;
                const roundedNumber = valueAnount.toFixed(2);
                return roundedNumber

            }



            public handleImageChange = (selectedImage: any) => {
                this.setState({ selectedFile: selectedImage });
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    cheque: selectedImage,
                });

            }

            public submitUserHandler = async () => {
                const dataTemp = {
                    payment_method: 'cheque',
                    plan_id: this.props?.newUserDetails?.subscriptionPlan?.id?.toString(),
                    addon_id: this.props?.newUserDetails?.addonPlan || [],
                    agreements: this.props?.newUserDetails?.agreementFile || "",
                    cheque: this.props?.newUserDetails?.cheque || "",
                    email: this.props?.user?.email || this.props?.newUserDetails?.email.toLowerCase() || "",
                    password:  this.props?.newUserDetails?.password || "",
                    firstName: this.props?.newUserDetails?.firstName || "",
                    lastName: this.props?.newUserDetails?.lastName || "",
                    schoolOrganization: this.props?.newUserDetails?.schoolOrganization || "",
                    mascot: this.props?.newUserDetails?.mascot || "",
                    phone: this.props?.newUserDetails?.phone || "",
                    schoolType: this.props?.newUserDetails?.schoolType || "",
                }

                this.setState({ loader: true })
                const data = new FormData();
                data.append('payment_method', dataTemp.payment_method);
                data.append('plan_id', dataTemp.plan_id);
                data.append('agreements', dataTemp.agreements);
                data.append('cheque', "");
                data.append('email', dataTemp.email);
                data.append('password', dataTemp.password);
                data.append('firstName', dataTemp.firstName);
                data.append('lastName', dataTemp.lastName);
                data.append('schoolOrganization', dataTemp.schoolOrganization);
                data.append('mascot', dataTemp.mascot);
                data.append('phone', dataTemp.phone);
                data.append('schoolType', dataTemp.schoolType);
                if (dataTemp?.addon_id?.length > 0) {
                    dataTemp.addon_id.map((itm: any) => {
                        data.append('addon_id[]', itm.toString());

                    })

                }
                const res: any = await this.buildPost(
                    this,
                    `payment/planPayConfirm`
                )(data);
                console.log("res=====>planPayConfirm", res)
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    paymentRes: res,
                });

                if (res?.status) {
                    setTimeout(() => {
                        this.setState({ loader: false })
                        this.props.history.push("/payment")
                    }, 2000);
                } else {
                    this.setState({ loader: false })
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });

            }

            public submitFreeUserHandler = async () => {

                // this.props.history.push("/payment")
                const dataTemp = {
                    payment_method: 'free',
                    plan_id: this.props?.newUserDetails?.subscriptionPlan?.id?.toString(),
                    agreements: this.props?.newUserDetails?.agreementFile || "",
                    email: this.props?.user?.email || this.props?.newUserDetails?.email.toLowerCase() || "",
                    password:  this.props?.newUserDetails?.password || "",
                    firstName: this.props?.newUserDetails?.firstName || "",
                    lastName: this.props?.newUserDetails?.lastName || "",
                    schoolOrganization: this.props?.newUserDetails?.schoolOrganization || "",
                    mascot: this.props?.newUserDetails?.mascot || "",
                    phone: this.props?.newUserDetails?.phone || "",
                    schoolType: this.props?.newUserDetails?.schoolType || "",
                }
                this.setState({ loader: true })
                const data = new FormData();
                data.append('payment_method', dataTemp.payment_method);
                data.append('agreements', dataTemp.agreements);
                data.append('email', dataTemp.email);
                data.append('password', dataTemp.password);
                data.append('firstName', dataTemp.firstName);
                data.append('lastName', dataTemp.lastName);
                data.append('plan_id', dataTemp.plan_id)
                data.append('schoolOrganization', dataTemp.schoolOrganization);
                data.append('mascot', dataTemp.mascot);
                data.append('phone', dataTemp.phone);
                data.append('schoolType', dataTemp.schoolType);
                const res: any = await this.buildPost(
                    this,
                    `payment/planRequest`
                )(data);
                console.log("res=====>planPayConfirm", res)
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    paymentRes: res,
                });
                this.setState({ loader: false })
                if (res?.status) {
                    this.props.history.push("/payment")
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            public async emailExistingCheck() {
                this.setState({ loader: true })
                const resEmail: any = await this.buildGet(this, `school/user/${this.props?.user?.email || this.props?.newUserDetails?.email}`)()
                console.log("resEmail======>", this.props.user.email, resEmail.status)
                if (Object.keys(resEmail?.status).length > 0) {
                    this.setState({ loader: false })
                    return false
                } else {
                    this.setState({ loader: false })
                    return true
                }
            }
            public render() {
                return (
                    <>

<div className="contat-main-bg-color">
                        {this.state.loader && <div className="loader-bg-color">
                            <LoadingSpinner /></div>}
                           
                        <Headerpage/>


                        <div className="container">

                            <div className="purchase-content">
                                <div className="row purchase-row">
                                    <div className="col-lg-8">
                                        {Object.keys(this.state?.paymentDetails)?.length > 0 && <div className="purchase-inner-content">
                                            <div className="purchase-inform check-inform"><h3>Check Information</h3></div>
                                            {Object?.keys(this.state?.paymentDetails?.plan)?.length > 0 && <div className="subscription-fee">
                                                <div className="subscription-fee-flex">
                                                    <div className="sub-yearly">
                                                        <h4>Subscription {this.state?.paymentDetails?.plan?.id === 1 ? "Fee" : "Fees"} <br />
                                                            ({this.state?.paymentDetails?.plan?.title}/{this.state?.paymentDetails?.plan?.payment_frequency_type.charAt(0).toUpperCase() + this.state?.paymentDetails?.plan?.payment_frequency_type.slice(1)})</h4>
                                                    </div>
                                                    <div>
                                                        <h3> ${this.TwoDecimalFloat(this.state?.paymentDetails?.plan?.price)}</h3>
                                                    </div>
                                                </div>
                                            </div>}
                                            {this.state?.paymentDetails?.addon?.length > 0 && this.state?.paymentDetails?.addon.map((item: any) => {
                                                return (
                                                    <div className="customizeable" key={item?.id}>
                                                        <div className="subscription-sub-flex">
                                                            <div className="sub-custom">
                                                                <h4>{item?.title}
                                                                    <br />
                                                                    (Add on) </h4>
                                                            </div>
                                                            <div>
                                                                <h3>${this.TwoDecimalFloat(item?.price)}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )

                                            })



                                            }
                                            {/* <ImageUploader ImageChange={this.handleImageChange} /> */}
                                            <div className="totalprice"><h3>Total: ${this.TwoDecimalFloat(this.state?.paymentDetails?.total)}</h3></div>
                                            {this.state?.paymentDetails?.total > 0 ? <>
                                                <div className="continuetosecure"
                                                    onClick={async () => {
                                                        console.log("this prop 1", this.props)
                                                        if(this.props?.user?.email || this.props?.newUserDetails?.email){
                                                        const isCheck = await this.emailExistingCheck()
                                                        if (isCheck) {
                                                            this.submitUserHandler()
                                                        } else {
                                                            alert("This email is already registered. Please try another one.")
                                                        }
                                                    }else{
                                                        alert("Complete sign-up flow first.")
                                                    }

                                                    }}
                                                >
                                                    <h5>Continue</h5>
                                                </div>

                                            </>
                                                : <>
                                                    <div className="continuetosecure" onClick={async () => {
                                                        console.log("this prop 2", this.props)
                                                          if(this.props?.user?.email || this.props?.newUserDetails?.email){
                                                        const isCheck = await this.emailExistingCheck()
                                                        if (isCheck) {
                                                            this.submitFreeUserHandler()
                                                        } else {
                                                            alert("This email is already registered. Please try another one.")
                                                        }
                                                    }else{
                                                        alert("Complete sign-up flow first.")
                                                    }

                                                    }}><h5>Continue</h5></div>
                                                </>}

                                        </div>}

                                    </div>

                                </div>
                            </div>

                        </div>


                        <Footerpage/>
                        </div>
                    </>
                );
            }
        }
    )
);



const HomeFunction = (props: any) => (
    <AppContextConsumer>{(context) => <Home {...context} history={props?.history} />}</AppContextConsumer>
);
export default withRouter(HomeFunction);












// WEBPACK FOOTER //
// ./src/pages/director/payment/PaybyCheque.tsx